module.exports = __webpack_public_path__ + "static/media/why_ja.a0a4e409.vtt";